module.exports = __webpack_public_path__ + "img/035-luxembourg.50680de2.svg";